import type { SupplementType } from 'modules/payroll_bundle/components/common/helper/worksheet'
import type { ImportData } from 'modules/payroll_bundle/lib/bulkImportSupplementsContext'
import { isValid } from 'modules/payroll_bundle/pages/SupplementsPage/BulkImport/_components/_Table/RowValidations'
import Supplement from 'modules/payroll_bundle/store/models/Supplement'

export default function filterSelectedValidRows({
  rows,
  selectedSupplements,
  supplementTypes,
}: {
  rows: ImportData[]
  selectedSupplements: Set<number>
  supplementTypes: SupplementType[]
}) {
  return rows.filter((row) => {
    // `row` has type ImportData and `isValid(supplement...)`
    // expects a Supplement, but in reality it only uses the attributes for
    // the supplement types, employee_id and legal_entity_id, which are also
    // ImportData properties. So it's possible to get the data in the desired
    // type by instantiating a Supplement from a `row`.
    const supplement = new Supplement(row)
    return selectedSupplements?.has(supplement.id) && isValid(supplement, supplementTypes)
  })
}
